import { Validators } from '@angular/forms';
import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { IPolicyAsset } from 'src/app/modules/shared/models/policy.model';
import { IGianosPolicyHolder, IGianosPolicyInsured, IGianosOperationInfo, IGianosDatiOperatore, IGianosEsecutoreConto, IGianosDesignazioneBeneficiari, IGianosTitolareEffettivo, IGianosPaymentMode } from '../../isv.constants';
import moment = require('moment');

export const prev_payment_form_template = {
  debitDate: moment(),
  iban: null,
  amount: null
};

export const prev_payment_form_validators = {
  debitDate: [Validators.required],
  iban: [Validators.required],
  amount: [Validators.required]
};

export const payment_form_template = {
  debitDate: { value: moment(), disabled: true },
  iban: null,
  amount: null,
  additionalPaymentLine: null,
  type: false
};

export const payment_form_validators = {
  debitDate: [Validators.required],
  iban: [Validators.required],
  amount: [Validators.required],
  type: [Validators.required]
};

export const prev_payment_form_keys: IFormKey[] = [
  {
    id: 'debit-date-field',
    label: 'Data Addebito',
    controlName: 'debitDate',
    css: 'col-3',
    type: 'DATEPICKER',
    minDate: moment(),
  },
  {
    id: 'iban-field',
    label: 'Coordinate bancarie',
    controlName: 'iban',
    css: 'col-3',
    type: 'SELECT',
    options: [],
  },
  {
    id: 'amount-field',
    label: 'Premio lordo',
    controlName: 'amount',
    type: 'INPUT',
    css: 'col-3',
    isAmountField: true,
  },
]
export const payment_form_keys: IFormKey[] = [
  {
    id: 'debit-date-field',
    label: 'Data Addebito',
    controlName: 'debitDate',
    css: 'col-3',
    type: 'DATEPICKER',
  },
  {
    id: 'iban-field',
    label: 'Coordinate bancarie',
    controlName: 'iban',
    css: 'col-3',
    type: 'SELECT',
    options: [],
  },
  {
    id: 'amount-field',
    label: 'Premio lordo',
    controlName: 'amount',
    type: 'INPUT',
    css: 'col-3',
    isAmountField: true,
  },
  {
    id: 'type-field',
    label: 'Modifica fondi',
    controlName: 'type',
    type: 'TOGGLE',
    css: 'col-3'
  }
];

export const preset_payment_form_keys: IFormKey[] = [
  {
    id: 'debit-date-field',
    label: 'Data Addebito',
    controlName: 'debitDate',
    css: 'col-4',
    type: 'DATEPICKER',
  },
  {
    id: 'iban-field',
    label: 'Coordinate bancarie',
    controlName: 'iban',
    css: 'col-4',
    type: 'SELECT',
    options: [],
  },
  {
    id: 'amount-field',
    label: 'Premio lordo',
    controlName: 'amount',
    type: 'INPUT',
    css: 'col-4',
    isAmountField: true,
  },
    {
    id: 'lines-field',
    label: 'Linea di investimento',
    controlName: 'additionalPaymentLine',
    type: 'SELECT',
    css: 'col-4',
    options: [],
  }
];

export const PREV_ADDITIONAL_PAYMENTS_ASSETS_TABLE_TABLE_KEYS: ITableKey[] = [
  {
    key: 'attributeDescription',
    label: 'Nome fondo',
  },
  {
    key: 'percentage',
    label: 'Percentuale Investimento (%)',
  },
  {
    key: 'amount',
    label: 'Importo da investire (€)',
  },
];

export const ADDITIONAL_PAYMENTS_ASSETS_TABLE_TABLE_KEYS: ITableKey[] = [
  {
    key: 'description',
    label: 'Nome fondo',
  },
  {
    key: 'percentage',
    label: 'Percentuale Investimento (%)',
  },
  {
    key: 'amount',
    label: 'Importo da investire (€)',
  },
];

export interface IAdditionalPaymentRequest {
  policyNumber: string,
  iban: string,
  codeRapporto: string,
  grossPremium: string,
  debitDate: string
}

export interface IAdditionalPaymentRequestIsv {
  policyNumber: string;
  contraente: IGianosPolicyHolder;
  assicurato: IGianosPolicyInsured;
  polizzaOperazione: IGianosOperationInfo;
  operatoreContraente: IGianosDatiOperatore;
  esecutoreConto?: IGianosEsecutoreConto;
  designazioneBeneficiario?: IGianosDesignazioneBeneficiari[];
  titolareEffettivi?: IGianosTitolareEffettivo[];
  paymentMode: IGianosPaymentMode;
  fundsList?: IPolicyAsset[];
  ndgTutoreODelegato: string;
  codiceLineaCompagnia?: string[];
  controvaloreLineaCompagnia?: string[];
  consultancyAmount: string;
  redemptionType?: string;
  policyValue?: string;
  depositType?: string;
  lineCode?: string;
  effectDate?: string;
}

export const vagg_operation_data_form_validators = {
    agencyCode: [Validators.required],
    policyNumber: [Validators.required],
    productCode: [Validators.required],
    productCategory: [Validators.required],
    reportScope: [Validators.required],
    additionalPaymentType: [Validators.required],
    redeemType: null,
    liquidationType: null,
    withdrawalType: null,
    operationAmount: null,
    paymentType: [Validators.required],
    fundOriginCountry: [Validators.required],
    fundOrigin: [Validators.required],
    fundOriginNote: null,
    designedBeneficiary: [Validators.required],
    contractorNotInsured: [Validators.required]
}
